export default __webpack_public_path__ + "static/media/3in1_ru.ddbe9207.svg";